export const CST = {
    SCENES: {
        LOAD: "LOAD",
        MENU: "MENU",
        GAMES: "GAMES"
    }
}